<template>
  <div :class="classes[props.type]">
    <div class="osk-wrapper">
      <div class="center_block">
        <h2 class="section-title">
          {{ title }}
        </h2>

        <div class="section-subtitle">
          {{ subtitle }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  title?: string
  subtitle?: string
  type: 'seller' | 'buyer'
}>(), {
  title: '',
  subtitle: '',
});

const classes = {
  seller: 'seller_top_title_block seller_buyer_top_title_block',
  buyer: 'buyer_top_title_block seller_buyer_top_title_block',
};
</script>

<style scoped lang="scss">
.seller_buyer_top_title_block {
  padding: 86px 0 82px;
  text-align: center;
  position: relative;
}

.seller_buyer_top_title_block:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 0;
}

.seller_top_title_block {
  background: url("assets/img/info/bg-seller.webp") no-repeat center center;
  background-size: cover;
}

.buyer_top_title_block {
  background: url("assets/img/info/bg-buyer.webp") no-repeat center center;
  background-size: cover;
}

@media only screen and (max-width: 400px) {
  .seller_top_title_block {
    background: url("assets/img/info/bg-seller_xs.webp") no-repeat center center;
    background-size: cover;
  }
}

@media only screen and (max-width: 1024px) {
  .seller_top_title_block {
    background: url("assets/img/info/bg-seller_sm.webp") no-repeat center center;
    background-size: cover;
  }

  .buyer_top_title_block {
    background: url("assets/img/info/bg-buyer_sm.webp") no-repeat center center;
    background-size: cover;
  }
}

.center_block {
  max-width: 500px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.center_block .section-title {
  color: #ffffff;
  font-size: 34px;
}

.center_block .section-subtitle {
  color: #E0E0E0;
  font-size: 14px;
  line-height: 21px;
  margin-top: 15px;
}

@media only screen and (max-width: 767px) {
  .seller_buyer_top_title_block {
    padding: 68px 0px 49px;
  }

  .seller_buyer_top_title_block .osk-wrapper {
    padding: 0;
  }

  .center_block .section-title {
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 1px;
  }

  .center_block .section-subtitle {
    font-size: 12px;
    line-height: 19px;
    margin-top: 10px;
    padding: 0 14px;
  }
}
</style>
